<template>
	<div class="container">
		<div class="content type_01">
			<div class="card mb_0">
				<h4 class="title mb_20">{{ $t('rtr_mypage-account.title') }}</h4>
				<div class="mb_10">
					<p class="mb_10">ID</p>
					<input
						type="text"
						readonly
						:placeholder="$store.state.auth.member_info.user_id"
					/>
				</div>
				<div class="mb_10">
					<p class="mb_10">{{ $t('rtr_mypage-account.name') }}</p>
					<input type="text" v-model="userName" />
				</div>
				<div class="mb_10">
					<p class="mb_10">{{ $t('rtr_mypage-account.email') }}</p>
					<input
						type="email"
						:placeholder="$store.state.auth.member_info.email_address"
						readonly
					/>
				</div>
				<div class="mb_10">
					<p class="mb_10">{{ $t('rtr_mypage-account.password') }}</p>
					<input
						type="password"
						v-model="oldPassword"
						:placeholder="$t('rtr_mypage-account.password')"
						autocomplete="off"
					/>
				</div>
				<div class="mb_10">
					<p class="mb_10">
						{{ $t('rtr_mypage-account.password') }}
					</p>
					<input
						type="password"
						:placeholder="$t('rtr_mypage-account.new_password1')"
						class="mb_10"
						v-model="newPassword"
					/>
					<input
						type="password"
						:placeholder="$t('rtr_mypage-account.new_password2')"
						v-model="confirmPassword"
					/>
				</div>
				<div class="button_area">
					<button class="button_bg_white mr_10" @click="init">
						{{ $t('button.cancel') }}
					</button>
					<button class="button_bg_red mr_10" @click="updateAccountHandler">
						{{ $t('button.change') }}
					</button>
					<button class="button_bg_black" @click="deleteAccountHandler">
						{{ $t('button.membership_withdrawal') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button v-if="status === 'delete'" @click="messageModalCancelHandler">
				{{ $t('rtr_auth-register.cancel') }}
			</button>
			<button class="fc_red oneBtn" @click="messageModalConfirmHandler">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import { deleteMember, updateMember, updateMemberPassword } from '@/api/member';
import { commonError } from '@/common/dialog';
import ModalMessage from '@/components/Layout/ModalMessage';

export default {
	name: 'Account',
	components: { ModalMessage },
	data() {
		return {
			userName: this.$store.state.auth.member_info.user_name,
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			status: 'update',
		};
	},
	methods: {
		init() {
			this.userName = this.$store.state.auth.member_info.user_name;
			this.oldPassword = '';
			this.newPassword = '';
			this.confirmPassword = '';
			this.status = 'update';
		},
		updateAccountHandler() {
			let executeFunctions;
			if (this.userName && !this.newPassword) {
				if (!this.validations('name')) return;
				executeFunctions = [this.updateUserName()];
			} else if (this.newPassword && !this.userName) {
				if (!this.validations('password')) return;
				executeFunctions = [this.updatePassword()];
			} else if (this.newPassword && this.userName) {
				if (!this.validations('all')) return;
				executeFunctions = [this.updateUserName(), this.updatePassword()];
			} else {
				this.modalIcon = 'error';
				this.modalStatusMessage = this.$t('modal.account.status1');
				this.messageModal = true;
				return;
			}
			Promise.all(executeFunctions)
				.then(() => {
					this.status = 'updateSuccess';
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.account.status2');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		async updateUserName() {
			const params = {
				user_name: this.userName,
				password: this.oldPassword,
			};
			await updateMember(params);
		},
		async updatePassword() {
			const params = {
				old_password: this.oldPassword,
				new_password: this.newPassword,
				confirm_password: this.confirmPassword,
			};
			await updateMemberPassword(params);
		},
		async deleteMember() {
			const params = {
				password: this.oldPassword,
			};
			await deleteMember(params)
				.then(() => {
					this.status = 'deleteSuccess';
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.account.status3');
					this.messageModal = true;
				})
				.catch(commonError);
		},
		messageModalConfirmHandler() {
			if (this.status === 'update') {
				this.messageModal = false;
			} else if (this.status === 'updateSuccess') {
				this.$store.dispatch('auth/getMemberInfo').then(() => {
					this.init();
					this.messageModal = false;
				});
			} else if (this.status === 'delete') {
				this.messageModal = false;
				this.deleteMember();
			} else if (this.status === 'deleteSuccess') {
				this.$store.dispatch('auth/logout');
				this.$router.push({ name: 'home' });
			}
		},
		deleteAccountHandler() {
			if (!this.validations('delete')) return;
			this.status = 'delete';
			this.modalIcon = 'warning';
			this.modalStatusMessage = this.$t('modal.account.status4');
			this.messageModal = true;
		},
		messageModalCancelHandler() {
			this.status = 'update';
			this.messageModal = false;
		},
		validations(type) {
			if (type === 'name' || type === 'all') {
				if (!this.userName) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status5');
					this.messageModal = true;
					return false;
				}
				if (!this.oldPassword) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status6');
					this.messageModal = true;
					return false;
				}
			} else if (type === 'password' || type === 'all') {
				if (!this.oldPassword) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status1');
					this.messageModal = true;
					return false;
				}
				if (!this.newPassword) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status7');
					this.messageModal = true;
					return false;
				}
				if (!this.confirmPassword) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status8');
					this.messageModal = true;
					return false;
				}
				if (this.newPassword !== this.confirmPassword) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status9');
					this.messageModal = true;
					return false;
				}
			} else if (type === 'delete') {
				if (!this.oldPassword) {
					this.modalIcon = 'error';
					this.modalStatusMessage = this.$t('modal.account.status6');
					this.messageModal = true;
					return false;
				}
			}
			return true;
		},
	},
};
</script>

<style scoped>
.rtr_mypage-account .button_area {
	text-align: center;
	margin-top: 130px;
}
</style>
